import { render, staticRenderFns } from "./personalSetting.vue?vue&type=template&id=1fdc5ef4&scoped=true"
import script from "./personalSetting.vue?vue&type=script&lang=js"
export * from "./personalSetting.vue?vue&type=script&lang=js"
import style0 from "./personalSetting.vue?vue&type=style&index=0&id=1fdc5ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc5ef4",
  null
  
)

export default component.exports